/**
 * Created by cc on 2016/9/28 0029.
 */
export default  {
    DISCARD_ACTION_NAME : '废弃',
    SAVE_ACTION_NAME : '保存',
    DEL_ACTION_NAME : '删除',
    UN_DISCARD_ACTION_NAME : '还原',
    GOBACK_ACTION_NAME : '回退',
}
module.exports = exports.default;